import { render, staticRenderFns } from "./GoodsDetails.vue?vue&type=template&id=5ab5fcd9&scoped=true"
import script from "./GoodsDetails.vue?vue&type=script&lang=js"
export * from "./GoodsDetails.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetails.vue?vue&type=style&index=0&id=5ab5fcd9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab5fcd9",
  null
  
)

export default component.exports